// extracted by mini-css-extract-plugin
export default {"Pulse":"CCPulse_Pulse__Xt-ke","PulseDot1":"CCPulse_PulseDot1__pf6-6","PulseDot2":"CCPulse_PulseDot2__eYl64","PulseDot3":"CCPulse_PulseDot3__ssyoy","puslse":"CCPulse_puslse__fUoEk"};